
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/inmobi",
      function () {
        return require("private-next-pages/destinations/inmobi.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/inmobi"])
      });
    }
  